export const COLORS_FILTER = [
  { name: 'Trắng', value: 'trang', className: 'bg-white ' },
  { name: 'Đen', value: 'den', className: 'bg-black' },
  { name: 'Xám', value: 'xam', className: 'bg-gray-400' },
  { name: 'Xanh Garment', value: 'xanh', className: 'bg-blue-700' },
  { name: 'Rêu', value: 'reu', className: 'bg-green-800' },
  { name: 'Hồng', value: 'hong', className: 'bg-pink-400' },
  { name: 'Nâu', value: 'nau', className: 'bg-amber-800' },
]

export const PRICE_FILTER = [
  { value: '0-200000', label: '0 - 200.000đ' },
  { value: '200000-300000', label: '200.000đ - 300.000đ' },
  { value: '300000-500000', label: '300.000đ - 500.000đ' },
  { value: '>500000', label: '>500.000đ' },
]

export const EXCLUDE_PATH_CONCAT_COLOR = [
  '/collection/flash-sale',
  '/graphic-tee',
  '/collection/care-and-share',
  '/collection/pickleball-tennis',
  '/collection/outdoor-collection',
  '/collection/quan-ao-phu-kien-tap-gym',
  '/collection/pickleball-tennis',
  '/collection/quan-ao-chay-bo',
  '/collection/the-thao-chung-nam',
]
